/* Collection links remain usable without this progressive enhancement. */
if (!customElements.get('yatdim-catalog')) {
  customElements.define('yatdim-catalog', class YatdimCatalog extends HTMLElement {
    #listeners = null;

    connectedCallback() {
      this.#listeners?.abort();
      this.#listeners = new AbortController();
      this.addEventListener('click', this.#handleClick, {signal: this.#listeners.signal});
    }

    disconnectedCallback() {
      this.#listeners?.abort();
      this.#listeners = null;
    }

    #handleClick = (event) => {
      if (!(event.target instanceof Element)) return;
      const selection = event.target.closest('[data-yatdim-product-select]');
      if (selection && this.contains(selection)) {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const data = selection.dataset;
        const useNativeAnchor = this.dispatchEvent(new CustomEvent('yatdim:product-selected', {
          bubbles: true,
          cancelable: true,
          detail: {
            contactId: data.contactId || 'contact',
            product: {
              id: data.productId,
              variantId: data.variantId,
              title: data.productTitle,
              variantTitle: data.variantTitle,
              sku: data.productSku,
              url: data.productUrl
            }
          }
        }));
        if (!useNativeAnchor) event.preventDefault();
        return;
      }

      const category = event.target.closest('[data-yatdim-category]');
      if (!category || !this.contains(category)) return;
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const panel = [...this.querySelectorAll('[data-yatdim-catalog-panel]')].find(item => item.id === category.dataset.yatdimCategory);
      if (!panel) return;
      event.preventDefault();
      for (const link of this.querySelectorAll('[data-yatdim-category]')) {
        if (link === category) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      }
      for (const item of this.querySelectorAll('[data-yatdim-catalog-panel]')) item.hidden = item !== panel;
      const status = this.querySelector('[data-yatdim-catalog-status]');
      if (status) {
        status.textContent = '';
        requestAnimationFrame(() => {
          if (this.isConnected) status.textContent = panel.dataset.announcement || '';
        });
      }
    };
  });
}
